import React from "react";

import Header from "../components/header";
import Footer from "../components/footer";
import Whatsapp from "../components/whatsapp";

import logoHeader from "../img/header-logo.svg";
import partnerImg from "../img/partner.svg";

import "../style/partnerPage.css";

function PartnerMainPage() {
    return (
        <React.Fragment>
            <Header />
            <div className="partner-container">
                <div className="partner-title">
                    <b>Seja nosso parceiro </b>
                    <img src={logoHeader} alt="logo-2k20" />
                </div>
                <div className="main-text">
                    <span>Conecte-se ao futuro com a 2K20!</span>
                    <span>Na 2K20, acreditamos que as melhores conexões vão além da tecnologia, elas criam oportunidades reais de crescimento. Nossa parceria é voltada exclusivamente para empresas e revendedores que desejam oferecer serviços de streaming e telefonia móvel, com condições diferenciadas e suporte completo.</span>
                    <span>Ao se tornar um parceiro 2K20, você amplia o portfólio do seu negócio com soluções modernas e acessíveis, garantindo mais valor, fidelização e lucro para os seus clientes.</span>
                </div>

                <div className="splited-section">
                    <div className="separator">
                        <div className="item-list">
                            <b>Foco em streaming e telefonia móvel</b>
                            <span>Ofereça aos seus clientes planos completos de conectividade e entretenimento com qualidade, estabilidade e benefícios exclusivos.</span>
                        </div>
                        <div className="item-list">
                            <b>Rentabilidade</b>
                            <span>Maior rentabilidade para seu negócio Tenha acesso a planos comerciais vantajosos e aumente seus ganhos com a revenda dos serviços 2K20.</span>
                        </div>
                        <div className="item-list">
                            <b>Suporte técnico e comercial especializado</b>
                            <span>Conte com acompanhamento dedicado da nossa equipe para facilitar o processo de vendas e garantir o melhor atendimento aos seus clientes.</span>
                        </div>
                        <div className="item-list last">
                            <b>Divulgação da sua marca</b>
                            <span>Seja reconhecido como parceiro oficial 2K20 e ganhe visibilidade junto a outras empresas do setor.</span>
                        </div>
                    </div>
                    <div className="separator">
                        <img src={partnerImg} alt="partner-image" />
                    </div>
                </div>

                <div className="cta-wrapper">
                    <b>Juntos, vamos levar mais conexão e entretenimento a todo o Brasil!</b>
                    <span>Entre em contato com nossos especialistas e descubra como se tornar um parceiro oficial 2K20.</span>
                    
                    <a href="/seja-parceiro/formulario">Quero ser parceiro</a>
                </div>
            </div>

            <Whatsapp/>
            <Footer />
        </React.Fragment>
    )
}

export default PartnerMainPage;